import { forwardRef, useImperativeHandle, useState } from 'react';
import { Spin, message, Drawer, Button, Tree } from "antd";
import { useRequest } from "ahooks";
import { langCommon } from "../../../locales";
import { MemberServer } from "../../../server";
import type { TreeProps } from 'antd';

const server = MemberServer.Role;

export const Privilege = forwardRef((props: any, ref: any) => {
    const { onSuccess, treeData } = props;
    const [roleId, setRoleId] = useState<any>()
    const [loading, setLoading] = useState<boolean>(false);
    const [visible, setVisiable] = useState<boolean>(false);
    const [checkedKeys, setCheckedKeys] = useState<any>([])

    useImperativeHandle(ref, () => ({
        changeVisible
    }))

    const changeVisible = (val: any) => {
        if (typeof val !== 'boolean') {
            setRoleId(val.Id)
            getRoutes({ Id: val.Id })
        }
        setVisiable(!!val);
    }

    const onCheck: TreeProps['onCheck'] = (checkedKeys, info) => {
        console.log(checkedKeys, info);
        setCheckedKeys(checkedKeys)
    };


    const { run: getRoutes } = useRequest(server.routes, {
        manual: true,
        onBefore: () => setLoading(true),
        onFinally: () => setLoading(false),
        onError: () => changeVisible(false),
        onSuccess: (res: any) => {
            setCheckedKeys(res.map((e: any) => e.RouteId));
        }
    });

    const { run: dispenseRoutes } = useRequest(server.dispenseRoutes, {
        manual: true,
        onBefore: () => setLoading(true),
        onFinally: () => setLoading(false),
        onError: () => changeVisible(false),
        onSuccess: (res: any) => {
            message.success(langCommon?.operateSuccess);
            onSuccess?.();
            changeVisible(false)
        }
    });

    const renderFooter = () => {
        return (
            <div className='flex align-center space-between'>
                <Button onClick={() => changeVisible(false)} >{langCommon?.cancel}</Button>
                <div className='txtr'>
                    <Button type='primary' loading={loading} onClick={() => {
                        dispenseRoutes({ Id: roleId, RouteIds: checkedKeys })
                    }} >{langCommon?.confirm}</Button>
                </div >
            </div>
        );
    }

    return (
        <div>
            <Drawer
                title={'分配权限'}
                width={800}
                closeIcon={null}
                open={visible}
                footer={renderFooter()}
                onClose={() => changeVisible(false)}
            >
                <Spin spinning={loading}>
                    <Tree
                        className='ml20'
                        checkable
                        selectable={false}
                        defaultExpandAll
                        checkedKeys={checkedKeys}
                        onCheck={onCheck}
                        treeData={treeData}
                        fieldNames={{ title: 'Title', key: 'Id', children: 'Children' }}
                    />
                </Spin>
            </Drawer>
        </div>
    );
})
